<template>
  <v-container fluid>
    <v-row>
      <v-col cols="9">
        <vue-apex-charts id="chart" width="100%" height="100" type="bar" :options="chartOptions" :series="chartSeries"/>
      </v-col>
      <v-col cols="3">
        <!-- TODO: Update to use variability instead of fixed 80, when available -->
        <pie-metric style="padding-top: 16px; margin-left: -35px;" :value="data.variability" :color="this.$vuetify.theme.themes.light.primary" :width="80" :height="80" :font-size="18"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import numbro from 'numbro'
import PieMetric from '@/components/simulationDetails/PieMetric.vue'

export default {
  data: function () {
    return {

    }
  },
  components: {
    VueApexCharts,
    PieMetric
  },
  methods: {
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    }
  },
  computed: {
    total: function () {
      if (this.chartSeries && this.chartSeries.length > 0) {
        return this.chartSeries.reduce((a, b) => {
          return a + b.data[0]
        }, 0)
      } else {
        return 0
      }
    },
    chartOptions: function () {
      return {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          show: false
        },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            show: false
          }
        },
        tooltip: {
          y: {
            formatter: (value) => {
              return `${this.formatValue(value)} (${this.formatValue(100 * value / this.total)}%)`
            }
          },
          x: {
            show: false
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'horizontal',
            shadeIntensity: 0.4,
            gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
            colorStops: []
          }
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        grid: {
          show: false,
          padding: {
            left: -10,
            top: -20
          }
        },
        colors: ['rgb(106, 176, 184)', 'rgb(47, 69, 84)', 'rgb(194, 53, 49)']
      }
    },
    chartSeries: function () {
      let series = []
      for (var key in this.data.distribution) {
        const value = this.data.distribution[key]
        series.push({
          name: key.slice(2, key.length),
          data: [value]
        })
      }
      return series
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
